import { Component, input, output } from '@angular/core';
import { SelectionArguments } from '../../../shared/models/selection-arguments';

import { MatSelectionList, MatListOption } from '@angular/material/list';
import { OrderListItemComponent } from '../online-order-list-item/order-list-item.component';
import { TranslatePipe } from '@ngx-translate/core';
import { OrderData } from '@lfw/roesberg.liveforms.core';

@Component({
  selector: 'lfw-online-order-list',
  templateUrl: './online-order-list.component.html',
  styleUrls: ['./online-order-list.component.css'],
  imports: [MatSelectionList, MatListOption, OrderListItemComponent, TranslatePipe]
})
export class OnlineOrderListComponent {
  data = input<OrderData[]>();
  itemSelected = output<SelectionArguments>();
  refreshOrders = output<void>();

  isLoading(): boolean {
    return !this.data();
  }

  hasNoData(): boolean {
    const data = this.data();
    return data?.length === 0;
  }

  onRefreshOrders(): void {
    this.refreshOrders.emit();
  }
}
